import { IconDefinition } from "./types";

/**
 * @deprecated Use `phone` instead. This icon will be removed in a future version.
 */
const telephone: IconDefinition = {
  iconName: "telephone",
  width: 576,
  height: 512,
  svgPathData:
    "M220.6 195l51.8-51-96-160-144 80 0 16c0 238.6 193.4 432 432 432l16 0 80-144-160-96-51 51.8C290.2 301 243.4 254.2 220.6 195zM408.1 332.6l87.8 52.7-43.6 78.5C249.9 457.5 86.9 294.6 80.6 92.1l78.5-43.6 52.7 87.8c-17 16.8-32.8 32.3-47.3 46.6l11.3 29.4c27.7 71.9 84.5 128.6 156.3 156.3l29.4 11.3c14.3-14.5 29.8-30.3 46.6-47.3z",
  iconType: "fill",
  unicode: 0xf095,
};

export { telephone };
